import { Link } from 'react-router-dom';
import { PiGraduationCapDuotone } from 'react-icons/pi';
import {
  ArrowRightOutlined,
  BulbOutlined,
  CheckCircleOutlined,
  CompassOutlined,
  MedicineBoxOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  StarOutlined,
  TeamOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import ContactMessageForm from '../components/ContactMessageForm';
import synteraLogoWhite from '../assets/syntera-hero-logo-white.png';
import '../styles/home.css';

const HomePage = () => {
  const stats = [
    {
      value: '4',
      title: 'Eğitimci',
      desc: 'Dermokozmetik, eczane danışmanlığı ve satış stratejilerinde uzman.',
    },
    {
      value: '95',
      title: 'Sene',
      desc: 'Toplam sektör tecrübemiz.',
    },
    {
      value: '40',
      title: 'Bin +',
      desc: 'Sektör profesyoneline eğitim.',
    },
    {
      value: '20',
      title: 'Bin + Gün',
      desc: 'Eczane danışmanlığı deneyimi.',
    },
    {
      value: '15',
      title: 'Milyon +',
      desc: 'Tüketiciye satış, servis ve hizmet deneyimi.',
    },
    {
      value: '1.',
      title: 'Günden',
      desc: 'Uygulama motivasyonu yaratan eğitim modeli.',
    },
  ];

  const audiences = [
    {
      title: 'Eczacılar, Öğrenciler ve Eczane Çalışanları',
      desc: 'Eczacılara, eczacılık fakültesi öğrencilerine ve eczane çalışanlarına özel; mesleki ve kişisel gelişimi destekleyen iş geliştirme eğitimleri sunuyoruz.',
      icon: <MedicineBoxOutlined />,
    },
    {
      title: 'Sağlık ve Güzellik Sektör Profesyonelleri',
      desc: 'Eczacılık, sağlık, OTC, kozmetik ve dermokozmetik sektörlerinde çalışan profesyoneller için özel hazırlanmış gelişim programları tasarlıyoruz.',
      icon: <SafetyCertificateOutlined />,
    },
    {
      title: 'Koçluk Temelli Gelişim Arayanlar',
      desc: 'Tüm sektörlere hitap eden koçluk temelli kişisel gelişim eğitimleriyle bireysel farkındalık, iletişim ve liderlik becerilerini güçlendiriyoruz.',
      icon: <BulbOutlined />,
    },
    {
      title: 'Kurumsal Yapılar ve İş Ortakları',
      desc: 'Kurumsal danışmanlık, ekip gelişimi ve çözüm ortaklığı modelleriyle markalara ve organizasyonlara stratejik destek veriyoruz.',
      icon: <TeamOutlined />,
    },
  ];

  const reasons = [
    {
      title: 'SYNTERA’da',
      items: [
        'Etik değerlere her koşulda bağlıyız.',
        'Karşılıklı deneyim paylaşımına ve uzun vadeli dönüşüm ortaklığına inanırız.',
        'Sektör uzmanlığımız, deneyimlerimiz ve kapsamlı içeriklerimiz ile öne çıkıyoruz.',
      ],
      icon: <RocketOutlined />,
    },
    {
      title: 'Eğitim İçeriğimiz',
      items: [
        'Uygulamaya yönelik nitelikli içerikler sunar, anlaşılır dil kullanırız.',
        'Bolca soru – cevap uygulamaları yaparız.',
        'Testler, workshoplar, role play’ler, oyunlar ile eğitimlerimizi renklendiririz.',
      ],
      icon: <PiGraduationCapDuotone />,
    },
    {
      title: 'Yaklaşımımız',
      items: [
        'Mizah olmadan olmaz deriz.',
        'Motivasyonun gücüne inanır, pozitif dil ve yaklaşımları benimseriz.',
        'Çeşitliliğin gücüne inanırız ve tüm iş ortaklarımıza saygı duyarız.',
      ],
      icon: <TrophyOutlined />,
    },
  ];

  const testimonials = [
    {
      name: 'ZORLU ECZANESI',
      role: 'Ecz. Pınar Arı Şentuğ',
      text: "Sadece 'bu ürün ne işe yarar' değil; etken maddelerin nasıl çalıştığını, ürünlerin dokusunu ve markaların serileri arasındaki farkları detaylarıyla öğrendik. Artık raftaki her ürünü gerçekten tanıyor ve danışana en uygun, nokta atışı ürünü sunuyoruz!",
    },
    {
      name: 'KEMER ECZANESI',
      role: 'Ecz. Burak Alp Taş',
      text: 'Bu kadar iyi bir eğitim gerçekten beklemiyordum. Açıkçası bakış açımı tamamen değiştirdiniz. Hastaya ve eczaneye sadece dermokozmetik değil, ilaç tarafında da nasıl yaklaşmam gerektiği konusunda bana yeni bir vizyon kazandırdınız. Eğitiminiz inanılmaz bir seviyede. Sizin sayenizde mesleğime yeniden aşık oldum.',
    },
    {
      name: 'YENIHAYAT ECZANESI',
      role: 'Ecz. Öznur Yıldırım',
      text: 'Teoriyi gerçek vakalarla harmanlayan bu eğitim sayesinde, öğrendiklerimi birinci günden itibaren eczanemde uygulayabiliyor ve farkı anında görebiliyorum. Diğer eğitimlerinize de katılmayı çok isterim.',
    },
    {
      name: 'GÜNEŞ ECZANESİ',
      role: 'Ecz. Ayşe Dedeoğlu Yazıcıoğlu',
      text: 'Sadece benim değil, tüm ekibimin işe bakışı değişti. Eğitimleri izleyen çalışma arkadaşlarımın artan özgüveni ve yükselen iş verimimiz beni gerçekten çok mutlu ediyor.',
    },
    {
      name: 'CEREN ECZANESİ',
      role: 'Ecz. Ceren Kayış',
      text: 'Eğitmenlerimizin engin bilgi birikimi, özverili hazırlıkları ve samimi anlatım tarzı tek kelimeyle ilham verici. Her izleyişte yepyeni ufuklar açılıyor.',
    },
    {
      name: 'ALP HABBEL ECZANESİ',
      role: 'Ecz. Mehmet Alp Habbel',
      text: 'Sadece güncel ürünleri değil; tüketiciyle güçlü bağ kurmayı, itirazları doğru yönetmeyi ve çapraz satış tekniklerini öğrenerek eczanemizdeki servis kalitesini zirveye taşıyacağız.',
    },
  ];

  return (
    <div className="syntera-home">

      {/* ── Hero ── */}
      <div className="hero-wrap">
        <div className="hero-inner">
          <div className="hero-main">
            <img src={synteraLogoWhite} alt="Syntera" className="hero-logo" />
            <p className="hero-slogan">‘‘Birlikte Dönüşüm’’ İçin En Yakın İş Ortağınız</p>
            <h1 className="hero-headline">
              <span className="hero-headline-accent">Sağlık ve Güzellik Sektör Profesyonellerine ;</span>{' '}
              <span className="hero-headline-accent">Eğitim ve İş Geliştirme Danışmanlığı</span>
            </h1>
            <p className="hero-sub">
              Eczacılar, ilaç, OTC ve dermokozmetik sektör profesyonelleri için uzman eğitmenler ile,
              sertifikalı programlar, mesleki gelişimi destekleyen eğitim ve iş geliştirme danışmanlığı sunuyoruz.
            </p>
            <div className="hero-cta-row">
              <Link to="/register" className="btn-primary-lg">
                Kayıt Ol <ArrowRightOutlined />
              </Link>
              <Link to="/akademilerimiz" className="btn-ghost-lg">
                Akademileri Keşfet
              </Link>
            </div>
          </div>

          {/* Side Card */}
          <div className="hero-card">
            <p className="hero-card-label">Neden Syntera?</p>
            <h3>“Birlikte Dönüşüm” için En Yakın İş Ortağınız</h3>
            <div className="hero-card-copy">
              <p><strong>SYNTERA’nın açılımı “Birlikte Dönüşüm Zamanı”dır.</strong></p>
              <p>
                Bu felsefeyle, kurumların ve bireylerin gelişim yolculuğuna stratejik, güvenilir ve çok yönlü çözümler sunuyoruz.
                Uzun yıllara dayanan sektör deneyiminin üzerine kurulan SYNTERA, alanında uzman eczacılarla birlikte; bilgi
                aktarmanın ötesine geçerek, gerçek ve sürdürülebilir dönüşüm süreçleri tasarlar.
              </p>
              <p>
                Logomuzdaki çember sürekli dönüşümü, eller ise bu yolculuğun ancak birlikte mümkün olduğunu simgeler.
              </p>
              <p>
                Çünkü biz inanıyoruz ki; gerçek gelişim, ancak doğru insanlarla, doğru zamanda ve birlikte mümkün.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ── Trust Bar ── */}
      <div className="trust-bar">
        <div className="trust-bar-inner" />
      </div>

      {/* ── Stats ── */}
      <div className="section section-alt stats-section">
        <div className="section-inner">
          <div className="stats-shell">
            <div className="stats-heading-block">
              <span className="section-label">Syntera Deneyimi</span>
              <h2 className="section-title stats-title">Sayılarla Biz</h2>
              <p className="stats-intro">
                Syntera, eczacılık, dermokozmetik ve sağlık sektörüne özel eğitim ve danışmanlık deneyimini;
                sahadan gelen ihtiyaçlar, ölçülebilir sonuçlar ve profesyonel gelişim odağıyla bir araya getirir.
              </p>
            </div>
            <div className="stats-grid">
            {stats.map((s) => (
              <div key={`${s.value}-${s.desc}`} className="stat-cell">
                <div className="stat-number-row">
                  <span className="stat-number">{s.value}</span>
                  {s.title ? <span className="stat-title">{s.title}</span> : null}
                </div>
                <div className="stat-label">{s.desc}</div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Misyon & Vizyon ── */}
      <div className="section section-center">
        <div className="section-inner">
          <span className="section-label">Yol Haritamız</span>
          <h2 className="section-title">Misyon &amp; Vizyon</h2>
          <div className="mv-grid">
            <div className="mv-card mv-card--blue">
              <div className="mv-icon"><StarOutlined /></div>
              <h3>Misyonumuz</h3>
              <div className="mv-copy">
                <p>
                  Eczacılık, sağlık, ilaç, kozmetik, Dermokozmetik, OTC başta olmak üzere, tüm sektörlerin gelişim ve dönüşümüne
                  katkı sağlamak amacıyla, çok yönlü eğitim ve danışmanlık hizmetlerini sizlere ulaştırmak için yola çıktık.
                </p>
                <p>
                  Kurum ve bireylerin mesleki, kişisel ve iş dünyasına yönelik gelişim ve dönüşüm süreçlerinde; uzman danışmanlarımızla
                  birlikte en yakın çözüm ortağınız olmayı hedefliyoruz.
                </p>
              </div>
            </div>
            <div className="mv-card mv-card--teal">
              <div className="mv-icon"><CompassOutlined /></div>
              <h3>Vizyonumuz</h3>
              <div className="mv-copy">
                <p>
                  Sağlık, eczacılık ve kozmetik sektörlerinde eğitim ve danışmanlık alanında sürdürülebilir dönüşümün referans noktası olmak.
                </p>
                <p>
                  Kurum ve bireylerin gelişim süreçlerine stratejik katkı sağlayarak uzun vadeli etki yaratmak.
                </p>
                <p>
                  Bilgi aktaran değil, dönüşüm tasarlayan bir yapı kurmak.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Hedef Kitlemiz ── */}
      <div className="section section-alt section-center testimonials-section">
        <div className="section-inner">
          <span className="section-label">Hedef Kitlemiz</span>
          <h2 className="section-title">Kimler İçin?</h2>
          <p className="section-sub">
            Sağlık ve Güzellik sektörü profesyonelleri için özel olarak tasarlanmış eğitim programlarımız ile kariyerinizi destekliyor,işinize ve kişisel gelişiminize katkı sunmayı hedefliyoruz
          </p>
          <div className="audience-grid">
            {audiences.map((a) => (
              <div key={a.title} className="audience-card">
                <div className="audience-icon">{a.icon}</div>
                <h3>{a.title}</h3>
                <p>{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Neden Biz ── */}
      <div className="section section-center">
        <div className="section-inner">
          <span className="section-label">Duruşumuz</span>
          <h2 className="section-title">Neden Bizden Eğitim ve Danışmanlık Almalısınız?</h2>
          <p className="section-sub">Gerçek dönüşüm,doğru iş ortağı ile başlar</p>
          <div className="features-grid">
            {reasons.map((r) => (
              <div key={r.title} className="feature-card">
                <div className="feature-icon">{r.icon}</div>
                <h3>{r.title}</h3>
                <ul className="reason-list">
                  {r.items.map((item) => (
                    <li key={item}><CheckCircleOutlined /> {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Testimonials ── */}
      <div className="section section-alt section-center">
        <div className="section-inner">
          <span className="section-label">Referanslar</span>
          <h2 className="section-title">Mezunlarımızın Yorumları</h2>
          <p className="section-sub">Eğitimlerimize katılan sağlık profesyonellerinin deneyimleri</p>
          <div className="testimonials-grid">
            {testimonials.map((t) => (
              <div key={t.name} className="testi-card">
                <div className="testi-stars">★★★★★</div>
                <p className="testi-text">"{t.text}"</p>
                <div className="testi-author-name">{t.name}</div>
                <div className="testi-author-role">{t.role}</div>
              </div>
            ))}
          </div>

          <div className="founder-message-card">
            <div className="founder-message-header">
              <h3>Kurucu Mesajı</h3>
            </div>
            <div className="founder-message-body">
              <p>
                İş ve insan hayatının sürekli bir dönüşüme ihtiyacı olduğunu ve bu sürecin aslında zorlu bir eylem olduğunu çok iyi biliyoruz.
                Zira dönüşüm; sabır, azim, cesaret, inanç, özdisiplin, motivasyon, hayalgücü ve vizyon gerektiriyor.
              </p>
              <p>
                Hepimiz, yıllar içerisinde bu güçlü sıfatlar ile yoğrularak değiştik ve dönüştük. Bu dönüşümler çoğunlukla zorluklarla mücadele ederek gerçekleşti;
                bazen muhteşem sonuçlar, bazen de bizi zorlayan sonuçlar getirdi. Günün sonunda, tüm bu eylemlerimiz hepimize çok uzun yılların tecrübesini kazandırdı.
              </p>
              <p>
                Ben ve danışma kurulumuzda yer alan iş ortaklarım, yolculuklarımızda özellikle Eczacılık, Sağlık, İlaç ve Kozmetik sektörlerinin ihtiyaç ve çözümlerini çok güçlü bir şekilde tecrübe ettik.
              </p>
              <p>
                Dünyanın bu kadar hızla değiştiği bir çağda, sizlerin de zorluklarla mücadele ederek elde ettiğiniz tecrübelerinizi çok değerli buluyoruz.
                Syntera Eğitim ve Danışmanlık şirketi çatısı altında tecrübelerimizi birleştirerek, "Birlikte Dönüşüm Çağı" misyonuyla yürüdüğümüz yolculukta en yakın çözüm ortağınız olmayı hedefliyoruz.
              </p>
              <p>
                Syntera olarak agresif büyüme hedeflerimiz yok. En iyi olmak, en görünür olmak ya da en büyük olmak önceliğimiz değil.
                Temel amacımız, etik ve insani değerlere bağlı kalarak, verimli, sonuç odaklı, uzun vadeli ve karşılıklı deneyim paylaşımı niyetiyle dönüşüm sağlamak.
              </p>
              <p>
                Kilometrelerce sürecek bir yola çıkıyoruz ve bu yolda yalnız olmadığımızı çok iyi biliyoruz. Birlikte dönüşüm ve gelişim felsefesine inanan;
                danışanlara, danışmanlara, öğrencilere, eczacılara ve tüm sektör çalışanlarına kadar aramızda herkese yer var. Duruşumuz hoşunuza gittiyse,
                gelin bu yeni yolculuğa hep birlikte çıkalım. Sizleri aramızda görmekten ve sizlerle birlikte iş ortaklığı yapmaktan mutluluk duyarız.
              </p>
            </div>
            <div className="founder-message-signature">Özge Yüksel Babaoğlu</div>
          </div>
        </div>
      </div>

      <section className="lead-capture-section">
        <div className="lead-capture-inner">
          <div className="lead-capture-copy">
            <span className="lead-copy-kicker">Syntera Akademi</span>
            <h2>Ekibimizle Hızlıca İletişime Geç</h2>
            <p>
              Eğitim danışmanlığı, kurumsal paketler ve iş birliği taleplerin için
              formu doldur; uzman ekibimiz sana en kısa sürede geri dönüş yapsın.
            </p>
            <div className="lead-copy-actions">
              <Link to="/register" className="btn-primary-lg">Kayıt Ol</Link>
              <Link to="/iletisim" className="btn-ghost-lg">İletişim Sayfası</Link>
              <Link to="/akademilerimiz" className="btn-ghost-lg">Akademileri Keşfet</Link>
            </div>
          </div>

          <ContactMessageForm title="Hızlı İletişim Formu" />
        </div>
      </section>

    </div>
  );
};

export default HomePage;
